import { render } from "./Dokumentasi.vue?vue&type=template&id=900aee6e"
import script from "./Dokumentasi.vue?vue&type=script&lang=js"
export * from "./Dokumentasi.vue?vue&type=script&lang=js"

import "./Dokumentasi.vue?vue&type=style&index=0&id=900aee6e&lang=css"

import exportComponent from "D:\\helmi\\blitarenergi\\vue\\companyprofile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__